import {CoverageDefinitionsBlock} from './CoverageDefinitionsBlock';
import {EligibilityBlock} from './EligibilityBlock';
import {ExclusionsAndLimitationsBlock} from './ExclusionsAndLimitationsBlock';
import {FundingStructureBlock} from './FundingStructureBlock';
import {RatingBlock} from './RatingBlock';
import {CensusClassSelection} from './CensusClassSelection';
import {FormBlock} from '../types';

const commonBlocks: FormBlock[] = [
  {FormBlock: CensusClassSelection, key: 'census-class-selection'},
  {FormBlock: CoverageDefinitionsBlock, key: 'coverage-definitions'},
  {FormBlock: FundingStructureBlock, key: 'funding-structure'},
  {FormBlock: EligibilityBlock, key: 'eligibility'},
  {FormBlock: ExclusionsAndLimitationsBlock, key: 'exclusions-and-limitations'},
  {FormBlock: RatingBlock, key: 'rating'},
];

export default commonBlocks;
